@if (preferences.isSecondaryNavigationExpanded() && title()) {
  <div class="secondary-menu__title">
    {{ title() }}
  </div>
}
<div
  class="secondary-menu"
  [class.secondary-menu--expanded]="preferences.isSecondaryNavigationExpanded() && !icons()"
  [class.secondary-menu--bottom]="bottom()"
>
  <div class="secondary-menu__menu">
    <ng-content />
  </div>
</div>
